/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTheme } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
// import Grid from '@mui/material/Grid';
// import TextField from '@mui/material/TextField';
// import Button from '@mui/material/Button';
// // import Divider from '@mui/material/Divider';
// import Avatar from '@mui/material/Avatar';
// import IconButton from '@mui/material/IconButton';
// import FacebookIcon from '@mui/icons-material/Facebook';
// import TwitterIcon from '@mui/icons-material/Twitter';
// import InstagramIcon from '@mui/icons-material/Instagram';

const Content = () => {
  const theme = useTheme();
 
  // const photos = [
  //   {
  //     src: 'https://assets.maccarianagency.com/backgrounds/img25.jpg',
  //     rows: 1,
  //     cols: 2,
  //   },
  //   {
  //     src: 'https://assets.maccarianagency.com/backgrounds/img22.jpg',
  //     rows: 1,
  //     cols: 1,
  //   },
  //   {
  //     src: 'https://assets.maccarianagency.com/backgrounds/img24.jpg',
  //     rows: 1,
  //     cols: 1,
  //   },
  //   {
  //     src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
  //     rows: 1,
  //     cols: 2,
  //   },
  // ];

  return (
    <Box>
      <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
        <Typography variant='h5' align='center'>
        SCINTILLA OF ART – CLASS 10 ART EXHIBITION – 2022
        </Typography>
        
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        To understand the importance of being socially responsible through significant tasks, the students of
Class – 10 Batch of 2022-23 enjoyed and experienced an array of art activities which enhanced their
understanding of how art, culture and economy are interwoven in a community.<br/><br/>
The art experience culminated as ‘SCINTILLA of ART’ – a fundraiser and a thoughtful initiative to connect
and contribute to the society by helping the underprivileged as part of Social Empowerment through
Work Education and Action (SEWA). The idea that was initially conceived by teachers to give an
understanding of cottage industries has lead to a new initiative and opportunity for the students. Under
the guidance of Principal and teachers, this project evolved as an excellent experiential learning for the
students.<br/><br/>
The SEWA activity helped students to understand about the various cottage and small-scale industries
and their contribution in strengthening the cultural heritage and economy of our country. Through Class
Assemblies, the students explored and recounted the abundance of art and culture and looked into the
opportunities available in the society to tap on their entrepreneurial skills. Prospects were created for
the students to set up a model of an industry. All the students of Class-10 were involved in making and
collecting the raw materials required for various products. The raw materials were eco-friendly reusable
and recycled materials. This was followed by a team of skilled students who undertook the responsibility
of making the artifacts and home decor and hosting the art exhibition.<br/><br/>
The students set up stalls selling a myriad of items such as diyas, plants and pots, coasters, table mats,
paintings, pens and pen stands. All the products were handmade and crafted by students.<br/><br/>
Through the entire course of this enterprise, students experienced how a business plan gets
conceptualised and consciously worked on designing manufacturing, pricing and selling the products.
Taking it further, the students spearheaded the idea of contributing the earnings obtained from the art
exhibition to help the lesser privileged by making generous donations to various orphanages and
understood the true meaning of giving it back to the society and the value of being charitable.<br/><br/>
        </Typography>

        
   
        <Typography
          variant={'h5'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        >
          “Imagine with all your mind. Believe with all your heart. Achieve with all your might”
        </Typography>
        <Box marginY={4}>
        </Box>
      </Box>
    </Box>
  );
};

export default Content;
